<template>
  <div class="scroller">
    <div class="list">
      <div class="list__heading">
        <h2>Screens</h2>
        <div>
          <router-link :to="{ name: 'screens.create'}" class="btn btn--primary btn--small">
              NEW SCREEN
          </router-link>
        </div>
      </div>

      <Loader v-if="isLoading" />
      <div class="listData" v-for="slider in sliders.data" :key="slider.id" v-else>
        <router-link :to="{ name: 'screens.edit', params: { id: slider.id }}" class="listData__link" @click="setSize()">
          <div class="listData__item">
            <h3 class="listData__heading mb0">{{ slider.title }}</h3>
          </div>
        </router-link>
        <button class="listData__delete" @click="deleteSlider(slider)">
          <font-awesome-icon :icon="['fal', 'trash-alt']"/>
        </button>
      </div>
    </div>
    <Pagination :pagination="sliders.pagination" :Resource="slider" :type="types.GET_ALL_SLIDERS" :isLoading="types.IS_LOADING_SLIDERS" :customParams="{screen_ip: true}"/>
  </div>
</template>

<script>
import * as types from '@/store/types.js'
import Slider from '@/model/Slider'
import Loader from '@/components/Utils/Loader'
import Pagination from '@/components/Utils/Pagination'
import {loadResource, deleteResource} from '@/helpers/resource'

export default {
  computed: {
    sliders () {
      return this.$store.getters[types.ALL_SLIDERS]
    },
    isLoading () {
      return this.$store.getters[types.IS_LOADING_SLIDERS]
    },
    types () {
      return types
    },
    slider () {
      return Slider
    }
  },
  components: {
    Loader, Pagination
  },
  mounted () {
    loadResource(Slider, types.GET_ALL_SLIDERS, types.IS_LOADING_SLIDERS, {screen_ip: true})
  },
  methods: {
    deleteSlider (slider) {
      deleteResource(types.REMOVE_SLIDER, slider)
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/Screen/ScreenList.vue